import $store from '@/store'
import { getRedirectUri } from '@/util'
// import { ignoreUrlByEquals, ignoreUrlByIndexOf } from './isIgnore'
// const ignoreUrls = ['/callback/kakao/token']
// const ignoreIndexOfUrls = ['/terms', '/signup', '/signin']

export default async (to, from, next) => {
  // 비 로그인 시 로그인 페이지로 redirect
  if (to?.meta?.requireSignin !== false && $store.getters['auth/isAuthenticated'] === false) {
    return next({ path: `/signin?redirectUri=${getRedirectUri(to)}` })
  }
  next()
}
